<template>
  <li class="w-full">
    <a
      href="#"
      class="flex w-full min-w-0 items-center border-l-2 py-2 pl-4 pr-2 text-[11px] leading-snug desk:pl-5 desk:text-xs"
      :class="
        categoryValue == $route.query.category
          ? 'border-primary bg-primary/[0.04] font-semibold text-primary'
          : 'border-transparent font-medium text-gray-500 desk:hover:bg-gray-50'
      "
      @click.prevent="switched"
    >
      <span class="min-w-0 flex-grow truncate text-left leading-tight">{{ category.name }}</span>
    </a>
  </li>
</template>

<script>
export default {
  props: {
    category: Object,
    isActive: Boolean,
  },
  computed: {
    categoryValue() {
      return this.category.no ?? this.category.id;
    },
  },
  methods: {
    switched() {
      this.mapQuery({
        category: this.categoryValue,
        title: this.category.name,
      });
    },
  },
};
</script>
